import { render, staticRenderFns } from "./IndustryService.vue?vue&type=template&id=129ddc4f&scoped=true&"
import script from "./IndustryService.vue?vue&type=script&lang=js&"
export * from "./IndustryService.vue?vue&type=script&lang=js&"
import style0 from "./IndustryService.vue?vue&type=style&index=0&id=129ddc4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ddc4f",
  null
  
)

export default component.exports